import { Injectable, Injector } from "@angular/core";
import { ObservablesService } from "../observables/observables";

@Injectable()
export class ReportEventService {

  constructor(
    private observables: ObservablesService
  ) { }

  addPageLoad(direction: string) {
    this.observables.ShouldPageLoadEvent = direction;
  }
}
